import { resolveCurrentMinistryName } from "@/pages/legislation/utils/ministryFilterOptions";
import useLegislationFilters from "@/hooks/useLegislationFilters";

interface MinistryRessortHintProps {
  ressort: string;
  /** Legislation datasource key; defaults to retsinformation. */
  sourceKey?: string;
  className?: string;
}

/**
 * When document metadata shows a historical ministry name (ressort), explains
 * which current filter option groups it under.
 */
export function MinistryRessortHint({
  ressort,
  sourceKey = "retsinformation",
  className,
}: MinistryRessortHintProps) {
  const { useGetFilterConfiguration } = useLegislationFilters();
  const { data: filterConfig } = useGetFilterConfiguration();

  const optionAliases =
    filterConfig?.sources?.[sourceKey]?.filters?.ministerium?.optionAliases;

  const canonical = resolveCurrentMinistryName(ressort, optionAliases);
  if (
    !canonical ||
    canonical.localeCompare(ressort, "da", { sensitivity: "accent" }) === 0
  ) {
    return null;
  }

  return (
    <p className={className ?? "text-xs text-muted-foreground"}>
      Filtreres under: {canonical}
    </p>
  );
}
